module.exports = __webpack_public_path__ + "static/img/stxt.aafb9c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stxt.png
// module id = Zawi
// module chunks = 0